import React from 'react';
import { FadeIn } from './FadeIn';
export function Guarantee() {
  return <section className="bg-navy-900 bg-grain py-24 border-y border-gold/20 relative" data-id="element-87">
      <div className="container mx-auto px-6 content-relative" data-id="element-88">
        <FadeIn className="max-w-3xl mx-auto bg-navy-800 border-2 border-gold rounded-2xl p-8 md:p-12 text-center shadow-[0_0_50px_rgba(212,180,100,0.15)] relative overflow-hidden" data-id="element-89">
          {/* Decorative glow */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-gold/5 blur-[100px] pointer-events-none" data-id="element-90"></div>

          <div className="text-6xl mb-6 relative z-10" data-id="element-91">🛡️</div>

          <h2 className="font-display font-bold text-3xl md:text-5xl text-white mb-8 relative z-10" data-id="element-92">
            GARANTÍA PIANO LISTO™ — 7 DÍAS
          </h2>

          <div className="space-y-4 text-lg md:text-xl text-gray-300 mb-8 relative z-10" data-id="element-93">
            <p data-id="element-94">
              Abrís los 6 tomos. Revisás los 6 bonos. Los usás en la clase si
              querés.
            </p>
            <p data-id="element-95">Si en 7 días no es lo que esperabas:</p>
            <p className="font-bold text-2xl md:text-3xl text-gold py-2" data-id="element-96">
              Te devolvemos el 100%.
            </p>
            <p className="italic font-accent text-xl" data-id="element-97">
              Sin preguntas. Sin formularios. Sin drama.
            </p>
          </div>

          <div className="w-16 h-px bg-gold/30 mx-auto mb-8 relative z-10" data-id="element-98"></div>

          <p className="text-sm md:text-base text-gray-400 leading-relaxed relative z-10" data-id="element-99">
            La confianza que tenemos en el MegaPack Piano Listo nos permite
            hacer esa promesa sin dudar. Más de 250 profes de piano de todo el
            país ya lo saben. La tasa de devoluciones es menor al 1%.
          </p>
        </FadeIn>
      </div>
    </section>;
}